var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8217 16.8627C33.8217 7.7514 26.444 0.365234 17.3432 0.365234C8.2424 0.365234 0.864746 7.7514 0.864746 16.8627C0.864746 25.0971 6.89067 31.9222 14.7684 33.1598V21.6315H10.5845V16.8627H14.7684V13.2281C14.7684 9.09343 17.2286 6.80957 20.9926 6.80957C22.7955 6.80957 24.6813 7.13178 24.6813 7.13178V11.1917H22.6034C20.5563 11.1917 19.918 12.4634 19.918 13.7681V16.8627H24.4882L23.7576 21.6315H19.918V33.1598C27.7957 31.9222 33.8217 25.0971 33.8217 16.8627Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6526 21.5398L24.3762 16.8159H19.8497V13.7504C19.8497 12.458 20.482 11.1983 22.5095 11.1983H24.5675V7.1766C24.5675 7.1766 22.6998 6.85742 20.9141 6.85742C17.186 6.85742 14.7494 9.11977 14.7494 13.2155V16.8159H10.6055V21.5398H14.7494V32.9595C15.5931 33.0919 16.4457 33.1582 17.2996 33.158C18.1672 33.158 19.0188 33.09 19.8497 32.9595V21.5398H23.6526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.0d81996f637b35c1b739b62ab8998d41.svg";
export { ForwardRef as ReactComponent };